import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Brain, Palette, Image, Building2, MapPin, Search, Star, User, Settings, HelpCircle, LogOut, Film } from 'lucide-react';
import { BottomNav } from '../components/BottomNav';
import { useAuth } from '../contexts/AuthContext';

const MenuItem = ({ icon: Icon, label, route, badge, onClick }) => {
  const navigate = useNavigate();
  return (
    <button onClick={onClick || (() => navigate(route))}
      className="w-full flex items-center gap-3 px-4 py-3 text-left active:bg-gray-50 transition-colors"
      data-testid={`more-${label.toLowerCase().replace(/\s/g, '-')}`}
    >
      <Icon size={18} className="text-[#128C7E] flex-shrink-0" />
      <span className="flex-1 text-sm font-medium text-slate-700">{label}</span>
      {badge && <span className="text-[10px] bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full font-medium">{badge}</span>}
    </button>
  );
};

const SectionLabel = ({ label }) => (
  <p className="px-4 pt-4 pb-1 text-[10px] font-bold text-gray-400 uppercase tracking-wider">{label}</p>
);

export const MoreScreen = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-[#F0F2F5] pb-20">
      <div className="w-full max-w-md mx-auto bg-white min-h-screen shadow-xl">
        <div className="bg-[#128C7E] text-white px-4 py-4"><h1 className="text-lg font-bold">More</h1></div>

        <SectionLabel label="SellGen AI" />
        <MenuItem icon={Brain} label="Brand Brain" route="/brand-brain" />
        <MenuItem icon={Image} label="Visual Library" route="/my-products" badge="Products" />
        <MenuItem icon={Film} label="Video Library" route="/video-library" />

        <div className="h-px bg-gray-100 mx-4" />

        <SectionLabel label="Business" />
        <MenuItem icon={Building2} label="Business Profile" route="/more/business-profile" />
        <MenuItem icon={MapPin} label="Locations" route="/more/business-profile" />
        <MenuItem icon={Search} label="Local SEO" route="/more/local-seo" />
        <MenuItem icon={Star} label="Reputation" route="/more/reputation" />

        <div className="h-px bg-gray-100 mx-4" />

        <SectionLabel label="Account" />
        <MenuItem icon={User} label="Account" route="/more/business-profile" />
        <MenuItem icon={Settings} label="Settings" route="/more/business-profile" />

        <div className="h-px bg-gray-100 mx-4" />

        <SectionLabel label="Support" />
        <MenuItem icon={HelpCircle} label="Help & Support" route="/privacy-policy" />

        <div className="h-px bg-gray-100 mx-4" />

        <button onClick={handleLogout}
          className="w-full flex items-center gap-3 px-4 py-3 text-left active:bg-red-50 transition-colors"
          data-testid="logout-btn"
        >
          <LogOut size={18} className="text-red-500" />
          <span className="text-sm font-medium text-red-600">Logout</span>
        </button>
      </div>
      <BottomNav />
    </div>
  );
};
